// Maps one row of the Top Influencer leaderboard (TOP_INFLUENCER_FILTERS.md
// §5) onto the shape InfluencerCard renders. The response is already close to
// display-ready - this mainly adds a stable React key. A username can
// legitimately appear on more than one platform (§2: "the same handle often
// exists on two platforms, and they are two accounts"), so platform+username
// together are what's actually unique, not username alone.
export const normalizeInfluencer = (raw) => {
  if (!raw) return raw
  return {
    ...raw,
    key: `${raw.platform}:${raw.username}`,
  }
}
